import './StepCard.css';

export default function StepCard({ step, icon, title, desc }) {
  return (
    <div className="stepcard">
      <div className="stepcard__num">{step}</div>
      <div className="stepcard__icon">{icon}</div>
      <h3 className="stepcard__title">{title}</h3>
      <p className="stepcard__desc">{desc}</p>
    </div>
  );
}
